<div class="w-50 p-3 d-none">
  <h3 class="mb-4 fw-bold">{{"title_account_manager"|translate}}</h3>
  <ul class="nav nav-tabs mb-4 pb-2" id="profileTabs" role="tablist">
    <li class="me-5" role="presentation" (click)="changeTab('info')">
      <span class="text-uppercase fw-bold {{shareObject.tab=='info'?'':'text-gray'}}" id="edit-info-tab"
        data-bs-toggle="tab" data-bs-target="#edit-info" type="button" role="tab" aria-controls="edit-info"
        aria-selected="true">
        {{"account_edit_info"|translate}}
      </span>
    </li>
    <li class="" role="presentation" (click)="changeTab('setting')">
      <span class="text-uppercase fw-bold {{shareObject.tab=='setting'?'':'text-gray'}}" id="account-settings-tab"
        data-bs-toggle="tab" data-bs-target="#account-settings" type="button" role="tab"
        aria-controls="account-settings" aria-selected="false">
        {{"account_setting"|translate}}
      </span>
    </li>
  </ul>
  <div class="tab-content" id="profileTabsContent">
    <!-- Tab 1: Chỉnh sửa thông tin -->
    <div *ngIf="shareObject.tab =='info'" id="edit-info" role="tabpanel" aria-labelledby="edit-info-tab">
      <div *ngIf="!shareObject.isLoading">
        <form [formGroup]="infoForm" (ngSubmit)="updateInfo()">
          <!-- Thông tin cá nhân -->
          <div class="mb-4">
            <h5 class="fw-bold">{{'account_info'|translate}}</h5>
            <div class="d-flex align-items-center justify-content-center mb-3">
              <div class="w-100" *ngIf="!infoForm?.value?.avatar">
                <div class="d-flex justify-content-center">
                  <label for="avatar-upload" for="avt" role="button" class="avt">
                    <div class="text-center">
                      <svg viewBox="0 0 24 24" width="20" height="20" fill="none" aria-labelledby="CameraIcon"
                        class="lava-c-PJLV lava-c-PJLV-hakyQ-display-block lava-c-PJLV-irQeQW-size-md">
                        <path
                          d="M4.8 19h14.4c.477 0 .935-.175 1.273-.488.337-.312.527-.736.527-1.177V9.44c0-.442-.19-.866-.527-1.178a1.877 1.877 0 0 0-1.273-.488h-3L14.4 5H9.6L7.8 7.775h-3c-.477 0-.935.176-1.273.488A1.604 1.604 0 0 0 3 9.441v7.894c0 .441.19.865.527 1.177.338.313.796.488 1.273.488Z"
                          stroke="currentColor" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round">
                        </path>
                        <path d="M12 15.81a3 3 0 1 0 0-6 3 3 0 0 0 0 6Z" stroke="currentColor" stroke-miterlimit="10"
                          stroke-linecap="round" stroke-linejoin="round"></path>
                      </svg>
                      <div>
                        <span class="text-decoration-underline">Tải ảnh</span>
                      </div>
                      <input type="file" (change)="selectAvatar($event)" id="avt" hidden accept="image/*">
                    </div>
                  </label>
                </div>
              </div>
              <div *ngIf="infoForm?.value?.avatar" class="d-flex justify-content-center">
                <div>
                  <label for="avt" class="d-flex justify-content-center" role="button">
                    <div class="text-center">
                      <img class="avt border border-2" src="{{infoForm.value?.avatar}}" alt="">
                      <span class="text-decoration-underline">Tải ảnh</span>
                    </div>
                    <input type="file" (change)="selectAvatar($event)" id="avt" hidden accept="image/*">
                  </label>
                </div>
              </div>
            </div>
            <div class="row g-3 mb-3">
              <div class="col-md-6">
                <label for="fullName" class="form-label fw-bold">{{'account_fullname'|translate}}</label>
                <input type="text" formControlName="name" class="form-control" id="fullName"
                  placeholder="Nguyễn Hữu Hiếu Thiên" />
              </div>
              <div class="col-md-6">
                <label for="phone" class="form-label fw-bold">{{'account_phone'|translate}}</label>
                <input type="text" formControlName="phone" class="form-control" id="phone" placeholder="0941549525" />
              </div>
            </div>
            <div class="row g-3">
              <div class="col-md-12">
                <label for="email" class="form-label fw-bold">{{'account_email'|translate}}</label>
                <input type="email" class="form-control" id="email" formControlName="email" readonly />
              </div>
            </div>
          </div>
          <!-- Submit Button -->
          <button type="submit" class="btn btn-primary py-1 rounded-1">{{"btn_save"|translate}}</button>
        </form>
      </div>
      <div *ngIf="shareObject.isLoading">
        <div>
          <div class="spinner-border spinner-border-sm text-secondary" role="status">
            <span class="visually-hidden">Loading...</span>
          </div>
        </div>
      </div>
    </div>

    <!-- Tab 2: Cài đặt tài khoản -->
    <div *ngIf="shareObject.tab =='setting'" id="account-settings" role="tabpanel"
      aria-labelledby="account-settings-tab">
      <form [formGroup]="changePassForm" (ngSubmit)="changePassword()">
        <!-- Đổi mật khẩu -->
        <div class="mb-4">
          <h5 class="fw-bold">{{"account_change_password"|translate}}</h5>
          <div class="mb-3">
            <label for="currentPassword" class="form-label">{{"account_current_password"|translate}}</label>
            <div class="input-group">
              <input type="password" formControlName="current_password" class="form-control" id="currentPassword"
                placeholder="{{'pld_current_password'|translate}}" />
              <button type="button" class="btn btn-outline-secondary">
                <i class="bi bi-eye-slash"></i>
              </button>
            </div>
            <a href="#" class="text-danger small">{{"account_fotgot_password"|translate}}?</a>
          </div>

          <div class="mb-3">
            <label for="newPassword" class="form-label">{{"account_new_password"|translate}}</label>
            <div class="input-group">
              <input type="password" formControlName="new_password" class="form-control" id="newPassword"
                placeholder="{{'pld_new_password'|translate}}" />
              <button type="button" class="btn btn-outline-secondary">
                <i class="bi bi-eye-slash"></i>
              </button>
            </div>
          </div>

          <div class="mb-3">
            <label for="confirmNewPassword" class="form-label">{{"account_confirm_password"|translate}}</label>
            <div class="input-group">
              <input type="password" formControlName="confirm_password" class="form-control" id="confirmNewPassword"
                placeholder="{{'pld_confirm_password'|translate}}" />
              <button type="button" class="btn btn-outline-secondary">
                <i class="bi bi-eye-slash"></i>
              </button>
            </div>
          </div>
          <!-- Gợi ý mật khẩu -->
          <ul class="text-muted small px-3 mt-3">
            <li>{{'desc_pass_has_8_character'|translate}}</li>
            <li>{{'desc_contain_1_uppercase'|translate}}</li>
            <li>{{'desc_contain_1_number'|translate}}</li>
            <li>{{'desc_contain_1_special_character'|translate}}</li>
          </ul>
          <button *ngIf="!shareObject.isLoading" type="submit"
            class="btn btn-primary rounded-1 py-1">{{"btn_save"|translate}}</button>
          <!-- tạo disable spinner button -->
          <button *ngIf="shareObject.isLoading" type="button" class="btn btn-danger py-1" disabled>
            <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
            {{'btn_loading'|translate}}
          </button>
        </div>
      </form>
    </div>
  </div>
</div>
<div class="w-100 p-3" *ngIf="!shareObject.isLoading">
  <div class="mb-3">
    <h3 class="mb-2 fw-bold">{{'account_info'|translate}}</h3>
    <div class="mb-2">
      <span class="text-muted fw-bold">{{'account_info_name'|translate}}</span> : <span>{{user?.profile?.name}}</span>
    </div>
    <div class="mb-2">
      <span class="text-muted fw-bold">{{'account_info_email'|translate}}</span> : <span>{{user?.email}}</span>
    </div>
    <div class="mb-2">
      <span class="text-muted fw-bold">{{'account_info_group'|translate}}</span> :
      <span>{{user?.profile?.employeeGroup?.name}}</span>
    </div>
  </div>
  <!-- tạo tab điểm danh và tăng ca -->
  <ul class="nav nav-tabs mb-4" id="attendanceTabs" role="tablist">
    <li class="nav-item" role="presentation">
      <button class="nav-link active" id="attendance-tab" data-bs-toggle="tab" data-bs-target="#attendance"
        type="button" role="tab" aria-controls="attendance"
        aria-selected="true">{{'user_attendance_list'|translate}}</button>
    </li>
    <li class="nav-item" role="presentation">
      <button class="nav-link" id="overtime-tab" data-bs-toggle="tab" data-bs-target="#overtime" type="button"
        role="tab" aria-controls="overtime" aria-selected="false">{{'user_overtime_list'|translate}}</button>
    </li>
    <li class="nav-item" role="presentation">
      <button class="nav-link" id="workcalendar-tab" data-bs-toggle="tab" data-bs-target="#workcalendar" type="button"
        role="tab" aria-controls="workcalendar" aria-selected="false">{{'user_work_calendar'|translate}}</button>
    </li>
    <li class="nav-item" role="presentation">
      <button class="nav-link" id="relocation-tab" data-bs-toggle="tab" data-bs-target="#relocation" type="button"
        role="tab" aria-controls="relocation" aria-selected="false">{{'user_relocation'|translate}}</button>
    </li>
    <li class="nav-item" role="presentation">
      <button class="nav-link" id="absence-tab" data-bs-toggle="tab" data-bs-target="#absence" type="button" role="tab"
        aria-controls="absence" aria-selected="false">{{'user_absence'|translate}}</button>
    </li>
    <li class="nav-item" role="presentation">
      <button class="nav-link" id="leave-tab" data-bs-toggle="tab" data-bs-target="#leave" type="button" role="tab"
        aria-controls="leave" aria-selected="false">{{'user_leave'|translate}}</button>
    </li>
  </ul>
  <div class="tab-content" id="attendanceTabsContent">
    <!-- Tab 1: Điểm danh -->
    <div class="tab-pane fade show active" id="attendance" role="tabpanel" aria-labelledby="attendance-tab">
      <div class="mb-3">
        <span class="btn btn-sm btn-primary rounded-1 me-2"
          routerLink="/user/employee/attendance/all-method">{{'btn_attendance'|translate}}
        </span>
      </div>
      <div class="col-md-6" *ngIf="shareObject.attendances && shareObject.attendances.length > 0">
        <h5>
          <span class="text-uppercase fw-bold">{{'attendance_history'|translate}}</span>
          <span class="text-muted">({{shareObject.attendances.length}})</span>
        </h5>
        <div class="mb-3 border p-2" *ngFor="let item of shareObject.attendances">
          <div class="fw-bold">
            {{item._id | date:'dd/MM/yyyy'}}
          </div>
          <div>
            <div *ngFor="let time of item.data">{{time.createdAt | date:'HH:mm:ss '}}</div>
          </div>
        </div>
      </div>
    </div>
    <!-- Tab 2: Tăng ca -->
    <div class="tab-pane fade show" id="overtime" role="tabpanel" aria-labelledby="overtime-tab">
      <div class="mb-3">
        <span class="btn btn-sm btn-info rounded-1"
          routerLink="/user/employee/overtime/request">{{'btn_ot_request'|translate}}
        </span>
      </div>
      <div class="" *ngIf="shareObject.overtimes && shareObject.overtimes.length > 0">
        <h5>
          <span class="text-uppercase fw-bold">{{'overtime_request_history'|translate}}</span>
          <span class="text-muted">({{shareObject.overtimes.length}})</span>
        </h5>
        <table class="table">
          <thead>
            <tr>
              <th scope="col">{{'date'|translate}}</th>
              <th scope="col">{{'time'|translate}}</th>
              <th scope="col">{{'status'|translate}}</th>
              <th scope="col">{{'approver'|translate}}</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let item of shareObject.overtimes">
              <td>{{item.start|date: 'dd/MM/yyyy'}}</td>
              <td>
                <span>{{item.start | date:'HH:mm:ss '}} - {{item.end | date:'HH:mm:ss '}}</span>
              </td>
              <td>
                <span *ngIf="item.status==2" class="text-primary">
                  <i class="bi bi-check-circle-fill text-primary"></i>
                  <span class="ms-2">{{'status_approved'|translate}}</span>
                </span>
                <span *ngIf="item.status==3" class=" text-danger">
                  <i class="bi bi-x-circle-fill text-danger"></i>
                  <span class="ms-2">{{'status_rejected'|translate}}</span>
                </span>
                <span *ngIf="item.status==1" class="text-warning">
                  <i class="bi bi-clock-fill text-warning"></i>
                  <span class="ms-2">{{'status_waiting'|translate}}</span>
                </span>
              </td>
              <td>
                <span *ngIf="item?.approver">
                  {{item?.approver?.profile?.name}}
                </span>
                <span *ngIf="!item?.approver">
                  {{item?.user?.profile?.name}}
                </span>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
    <!-- Tab 3: Lịch làm việc -->
    <div class="tab-pane fade show" id="workcalendar" role="tabpanel" aria-labelledby="workcalendar-tab">
      <!-- <div class="" *ngIf="shareObject.workCalendar">
        <h5>
          <span class="text-uppercase fw-bold">{{'user_work_calendar'|translate}}</span>
        </h5>
        <div class="row">
          <div *ngFor="let timesheet of shareObject.workCalendar.timesheet" class="col-md-6 mb-3">
            <div class="fw-bold">
              {{timesheet.name}}
            </div>
            <div class="mb-3 border p-2 d-block d-sm-block d-md-flex d-lg-flex d-xl-flex gap-2"
              *ngFor="let workDay of timesheet.workDays">
              <div class="col-2">
                <span class="fw-bold">{{workDay.dayText}}</span>
              </div>
              <div *ngIf="!workDay.isDayOff">
                <span>{{workDay.start}} -> {{workDay.end}}</span>
              </div>
              <div *ngIf="workDay.isDayOff">
                <span class="text-danger">{{'timesheet_dayoff'|translate}}</span>
              </div>
            </div>
          </div>
        </div>
      </div> -->
      <table class="table">
        <thead>
          <tr>
            <th scope="col">{{'date'|translate}}</th>
            <th scope="col">{{'dayofweek'|translate}}</th>
            <th scope="col" *ngFor="let item of shareObject.workDataShift">{{item}}</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let item of shareObject.workData">
            <td>{{item.date}}</td>
            <td>{{item.day|translate}}</td>
            <td *ngFor="let shift of item.shifts">
              {{shift.time}}
            </td>
          </tr>
        </tbody>
      </table>
    </div>
    <!-- Tab 4: Điều chuyển -->
    <div class="tab-pane fade show" id="relocation" role="tabpanel" aria-labelledby="relocation-tab">
      <div class="mb-3">
        <span class="btn btn-sm btn-info rounded-1"
          routerLink="/user/employee/relocation/request">{{'btn_relocation_request'|translate}}
        </span>
      </div>
      <table class="table">
        <thead>
          <tr>
            <th scope="col">{{'relocation_from_date'|translate}}</th>
            <th scope="col">{{'relocation_to_date'|translate}}</th>
            <th scope="col">{{'relocation_work_time'|translate}}</th>
            <th scope="col">{{'relocation_store'|translate}}</th>
            <th scope="col">{{'relocation_status'|translate}}</th>
            <th scope="col">{{'approver'|translate}}</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let item of shareObject.relocations">
            <td>{{item.startDate|date: 'dd/MM/yyyy'}}</td>
            <td>{{item.endDate|date: 'dd/MM/yyyy'}}</td>
            <td>
              <span>{{item.startTime}} - {{item.endTime}}</span>
            </td>
            <td>
              <span>{{item?.store?.name}}</span>
            </td>
            <td>
              <span *ngIf="item.status==2" class="text-primary">
                <i class="bi bi-check-circle-fill text-primary"></i>
                <span class="ms-2">{{'status_approved'|translate}}</span>
              </span>
              <span *ngIf="item.status==3" class=" text-danger">
                <i class="bi bi-x-circle-fill text-danger"></i>
                <span class="ms-2">{{'status_rejected'|translate}}</span>
              </span>
              <span *ngIf="item.status==1" class="text-warning">
                <i class="bi bi-clock-fill text-warning"></i>
                <span class="ms-2">{{'status_waiting'|translate}}</span>
              </span>
            </td>
            <td>
              <span *ngIf="item?.approver">
                {{item?.approver?.profile?.name}}
              </span>
              <span *ngIf="!item?.approver">
                {{item?.user?.profile?.name}}
              </span>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
    <!-- Tab 5: Xin nghỉ phép -->
    <div class="tab-pane fade show" id="absence" role="tabpanel" aria-labelledby="absence-tab">
      <div class="mb-3">
        <span class="btn btn-sm btn-info rounded-1"
          routerLink="/user/employee/absence/request">{{'btn_absence_request'|translate}}
        </span>
      </div>
      <table class="table">
        <thead>
          <tr>
            <th scope="col">{{'absence_start'|translate}}</th>
            <th scope="col">{{'absence_end'|translate}}</th>
            <th scope="col">{{'absence_reason'|translate}}</th>
            <th scope="col">{{'absence_status'|translate}}</th>
            <th scope="col">{{'approver'|translate}}</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let item of shareObject.absences">
            <td>{{item.start|date: 'dd/MM/yyyy HH:mm'}}</td>
            <td>{{item.end|date: 'dd/MM/yyyy HH:mm'}}</td>
            <td>{{item.reason}}</td>
            <td>
              <span *ngIf="item.status==2" class="text-primary">
                <i class="bi bi-check-circle-fill text-primary"></i>
                <span class="ms-2">{{'status_approved'|translate}}</span>
              </span>
              <span *ngIf="item.status==3" class=" text-danger">
                <i class="bi bi-x-circle-fill text-danger"></i>
                <span class="ms-2">{{'status_rejected'|translate}}</span>
              </span>
              <span *ngIf="item.status==1" class="text-warning">
                <i class="bi bi-clock-fill text-warning"></i>
                <span class="ms-2">{{'status_waiting'|translate}}</span>
              </span>
            </td>
            <td>
              <span *ngIf="item?.approver">
                {{item?.approver?.profile?.name}}
              </span>
              <span *ngIf="!item?.approver">
                {{item?.user?.profile?.name}}
              </span>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
    <!-- Tab 6: Xin ra ngoài -->
    <div class="tab-pane fade show" id="leave" role="tabpanel" aria-labelledby="leave-tab">
      <div class="mb-3">
        <span class="btn btn-sm btn-info rounded-1"
          routerLink="/user/employee/leave/request">{{'btn_leave_request'|translate}}
        </span>
      </div>
      <table class="table">
        <thead>
          <tr>
            <th scope="col">{{'leave_start'|translate}}</th>
            <th scope="col">{{'leave_end'|translate}}</th>
            <th scope="col">{{'leave_reason'|translate}}</th>
            <th scope="col">{{'leave_status'|translate}}</th>
            <th scope="col">{{'approver'|translate}}</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let item of shareObject.leaves">
            <td>{{item.start|date: 'dd/MM/yyyy HH:mm'}}</td>
            <td>{{item.end|date: 'dd/MM/yyyy HH:mm'}}</td>
            <td>{{item.reason}}</td>
            <td>
              <span *ngIf="item.status==2" class="text-primary">
                <i class="bi bi-check-circle-fill text-primary"></i>
                <span class="ms-2">{{'status_approved'|translate}}</span>
              </span>
              <span *ngIf="item.status==3" class=" text-danger">
                <i class="bi bi-x-circle-fill text-danger"></i>
                <span class="ms-2">{{'status_rejected'|translate}}</span>
              </span>
              <span *ngIf="item.status==1" class="text-warning">
                <i class="bi bi-clock-fill text-warning"></i>
                <span class="ms-2">{{'status_waiting'|translate}}</span>
              </span>
            </td>
            <td>
              <span *ngIf="item?.approver">
                {{item?.approver?.profile?.name}}
              </span>
              <span *ngIf="!item?.approver">
                {{item?.user?.profile?.name}}
              </span>
            </td>
          </tr>
        </tbody>
      </table>

    </div>
    <div class="w-100 p-3" *ngIf="shareObject.isLoading">
      <div>
        <div class="spinner-border spinner-border-sm text-secondary" role="status">
          <span class="visually-hidden">Loading...</span>
        </div>
      </div>
    </div>